module.exports = __webpack_public_path__ + "9ce4d1b1fed3d25bfd930df6f5761550.svg";